import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scroll to top on route change. React Router v7 keeps the scroll position
 * by default, which is jarring after navigating to a different page. If the
 * URL carries a hash (e.g. `/#archive`), scroll that element into view
 * instead — this is what makes cross-page anchor links like the AppBar's
 * "Watch" item land on the right section.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
}
